import { generatePath } from 'react-router';
import { paths } from '../../../common/constants/pathVariables.js';
import {
  costCenterMsg,
  idNumberMsg,
  numberOfTheBillingAccountMsg,
  pukCodeMsg,
  referenceMsg,
  simCardNumberMsg,
  subscriptionNumberMsg,
  t,
} from '../../../common/i18n/index.js';
import { getSubscriptionUrlId } from '../../../common/utils/subscriptionUtils.js';
import { getSubscriptionStatusText } from '../../SubscriptionDetails/subscriptionDetailsCommon.js';
import { SearchResultRow } from '../SearchResultRow.js';
import { HeaderSectionContent, SectionContent } from '../SectionContent.js';
import { getResultObjectWithHighlightedValues } from '../highlightFunctions.js';
import type { SubscriptionHeader } from '../../../generated/api/subscriptionHeader.js';
import type { SearchResultBaseProps } from '../SearchResultRow.js';

export interface InternetSubscriptionProps extends SearchResultBaseProps {
  subscription: SubscriptionHeader;
}

export const InternetSubscription = ({
  subscription,
  matchedFields,
  searchTerms,
  ...rest
}: InternetSubscriptionProps) => {
  const {
    subscriptionName,
    subscriptionPurposeOfUse,
    subscriptionContactName,
    billingAccountDisplayId,
    simCardNumber,
    costCenter,
    subscriptionReference,
    subscriptionDisplayId,
    subscriptionUserFriendlyId,
    puk1,
  } = getResultObjectWithHighlightedValues(subscription, matchedFields, searchTerms);
  return (
    <SearchResultRow
      icon="broadband"
      upperSection={
        <HeaderSectionContent
          left={subscriptionName || ''}
          right={subscriptionContactName || subscriptionPurposeOfUse}
        />
      }
      lowerSection={
        <SectionContent
          left={getSubscriptionStatusText(subscription.subscriptionStatus) || ''}
          right={
            puk1 && (
              <>
                {t.K5TL(pukCodeMsg)}: {puk1}
              </>
            )
          }
        />
      }
      additionalHighlightableFields={[
        { title: t.VLQ3(simCardNumberMsg), value: simCardNumber, key: 'simCardNumber' },
        { title: t.GQLW(numberOfTheBillingAccountMsg), value: billingAccountDisplayId, key: 'billingAccountDisplayId' },
        { title: t.L2OG(costCenterMsg), value: costCenter, key: 'costCenter' },
        { title: t.LVRN(referenceMsg), value: subscriptionReference, key: 'subscriptionReference' },
        { title: t.YTH3(idNumberMsg), value: subscriptionDisplayId, key: 'subscriptionDisplayId' },
        { title: t.DP44(subscriptionNumberMsg), value: subscriptionUserFriendlyId, key: 'subscriptionUserFriendlyId' },
      ]}
      matchedFields={matchedFields}
      linkHref={`${generatePath(paths.PS_BROADBAND_SUBSCRIPTION, { subscriptionId: getSubscriptionUrlId(subscription) })}?mdmId=${subscription.accountMasterId}`}
      {...rest}
    />
  );
};
